import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { Avatar, AvatarFallback } from './ui/avatar';
import { testimonials as mockTestimonials } from '../data/mock';

const Testimonials = ({ cms }) => {
  const d = cms || {};
  const title = d.title || 'What Our Customers Say';
  const subtitle = d.subtitle || 'Testimonials';
  const items = (d.testimonials && d.testimonials.length > 0) ? d.testimonials : mockTestimonials;

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-white reveal-on-scroll" data-testid="testimonials-section">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="text-xs sm:text-sm font-semibold text-blue-700 uppercase tracking-wider mb-3">{subtitle}</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
            {title.includes('Customers') ? <>{title.replace('Customers Say', '')}<span className="text-blue-700">Customers Say</span></> : title}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 max-w-6xl mx-auto">
          {items.map((t, idx) => (
            <div key={t.id || idx} className="bg-gray-50 border border-gray-200 rounded-xl p-4 sm:p-5 hover:shadow-md transition-shadow" data-testid={`testimonial-${t.id || idx}`}>
              <div className="flex gap-0.5 mb-3">
                {[...Array(t.rating || 5)].map((_, i) => (
                  <Star key={i} size={13} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-4">"{t.text || t.content}"</p>
              <div className="flex items-center gap-2.5 pt-3 border-t border-gray-200">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-blue-700 text-white text-[10px] font-semibold">
                    {(t.name || 'U').split(' ').map(n => n[0]).join('')}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <div className="text-xs sm:text-sm font-semibold text-gray-900">{t.name}</div>
                  <div className="flex items-center gap-1 text-[10px] sm:text-xs text-gray-400">
                    <MapPin size={9} />{t.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 sm:mt-10 text-center">
          <div className="inline-flex items-center gap-3 bg-gray-50 rounded-full px-5 sm:px-6 py-2.5 sm:py-3 border border-gray-200">
            <div className="flex -space-x-2">
              {['R','P','A','S','M'].map((letter, i) => (
                <Avatar key={i} className="h-7 w-7 sm:h-8 sm:w-8 border-2 border-white">
                  <AvatarFallback className="bg-blue-700 text-white text-[9px] sm:text-[10px] font-semibold">{letter}</AvatarFallback>
                </Avatar>
              ))}
            </div>
            <div className="text-left">
              <div className="text-xs sm:text-sm font-bold text-gray-900">5000+ Happy Customers</div>
              <div className="flex items-center gap-1 text-[10px] sm:text-xs text-gray-500">
                <Star size={10} className="fill-amber-400 text-amber-400" />
                <span className="font-semibold">4.9/5</span> avg rating
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
